import axios from 'axios';

const normalizeApiBase = (rawValue) => {
  const value = (rawValue || '').trim();
  if (!value) {
    return '/api';
  }

  const trimmed = value.replace(/\/+$/, '');

  if (trimmed === '/auth' || trimmed.endsWith('/auth')) {
    return `${trimmed.slice(0, -5)}/api` || '/api';
  }

  if (trimmed === '/api' || trimmed.endsWith('/api')) {
    return trimmed;
  }

  if (trimmed.startsWith('http://') || trimmed.startsWith('https://') || trimmed.startsWith('/')) {
    return `${trimmed}/api`;
  }

  return '/api';
};

const defaultApiBase = process.env.NODE_ENV === 'development'
  ? 'http://127.0.0.1:8000/api'
  : '/api';

const API_URL = normalizeApiBase(process.env.REACT_APP_API_URL || defaultApiBase);

const apiClient = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default apiClient;
